import { makeAutoObservable } from "mobx"
import {  getStockDetailData } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType } from "../../shared/utils"

class Store {
  constructor() {
    if (getPageType() == PageType.全球债券) {
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null
  

  async init() {
    this.getData()

    setInterval(() => {
      this.getData()
    }, 30 * 1000)
  }

  async getData() {
    let data = await getStockDetailData(window.quotedata.quotecode, "f19,f20,f39,f40,f43,f44,f45,f46,f47,f48,f49,f50,f51,f52,f57,f59,f60,f71,f107,f152,f154,f169,f170,f292,f532,f703,f734,f753,f754,f755,f758,f759,f761,f762,f763,f764")
    this.setStockDetail(data)
  }

  setStockDetail(StockDetail: any) { 
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }
}

export const store = new Store()
